import RunningAndGrowingWrapper from './RunningAndGrowingWrapper';

export default RunningAndGrowingWrapper;
